__turbopack_context__.v({
  "button": "LoginBar-module-scss-module__Rljfsa__button",
  "button--disabled": "LoginBar-module-scss-module__Rljfsa__button--disabled",
  "button--flat": "LoginBar-module-scss-module__Rljfsa__button--flat",
  "button--full": "LoginBar-module-scss-module__Rljfsa__button--full",
  "buttonSecondary": "LoginBar-module-scss-module__Rljfsa__buttonSecondary",
  "loginBar": "LoginBar-module-scss-module__Rljfsa__loginBar",
  "loginBar__link": "LoginBar-module-scss-module__Rljfsa__loginBar__link",
});
